import { KatIcon } from "@amzn/katal-react";
import classNames from "classnames";
import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "../../styles.module.scss";

const CustomPopover: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.popover_container)}>
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        <KatIcon name="info-circle" size="xsmall" />
      </div>
      {isVisible && (
        <div className={styles.popover_content}>
          {t("aic_doc_page_inbound_document_compliance_helper_info_tooltip")}
        </div>
      )}
    </div>
  );
};

export default CustomPopover;
